var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStressIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 76,
    viewBox: "0 0 50 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13185_1832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2503 76.1017C18.4503 73.3151 16.9003 64.7524 16.4503 62.9284C16.2503 62.1177 15.9003 61.9657 15.1503 62.0671C13.2003 62.3204 11.2003 62.4724 9.25035 62.4724C7.30035 62.4724 6.20035 60.2937 6.10035 58.3177C6.05035 57.3551 6.05035 56.3924 6.40035 55.4804C6.65035 54.7204 6.60035 54.0111 6.10035 53.4031C5.55035 52.7444 5.60035 52.1364 6.05035 51.4777C6.30035 51.1737 6.45035 50.9204 5.95035 50.6164C5.20035 50.2111 5.10035 49.5524 5.45035 48.8431C5.50035 48.6911 5.55035 48.5897 5.60035 48.4377C6.15035 46.8671 6.15035 46.8164 4.55035 46.3097C2.50035 45.6004 2.10035 44.3844 3.55035 42.7631C4.90035 41.1924 6.35035 39.7737 7.80035 38.3044C8.70035 37.3924 9.00035 36.0244 9.20035 34.8084C9.45035 33.3391 10.0503 28.5257 10.2003 27.6644C12.3503 16.4164 24.0003 17.3791 26.6503 17.7337C26.6503 17.7337 34.3503 18.2911 40.2503 22.5977C54.4503 34.9097 43.9003 48.1337 41.9003 50.4644C35.4003 56.1897 41.2503 68.9577 41.2503 68.9577C41.2503 68.9577 42.5003 73.2137 50.0003 76.1017",
    stroke: "#A977F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3496 27.1064C34.3496 27.1064 37.3996 27.8664 36.7496 31.4131",
    stroke: "#C924A4",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5996 30.7549C35.5996 30.7549 39.9996 32.3762 37.3996 36.5309",
    stroke: "#C924A4",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4506 29.0824C22.4506 29.0824 22.2506 24.6744 26.7506 24.269C27.0506 24.269 31.2506 23.8637 31.6506 29.0824",
    stroke: "#C924A4",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3007 32.7812C18.3007 32.7812 16.0507 25.7892 23.3007 26.1439",
    stroke: "#C924A4",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0003 30.1465C18.0003 30.1465 14.4003 32.0718 16.9503 35.5172C17.2503 35.8212 19.3503 37.7465 22.0503 35.5172",
    stroke: "#C924A4",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1992 27.0049C31.1992 27.0049 34.6992 27.2582 34.4492 31.4129",
    stroke: "#C924A4",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0508 30.7549C32.0508 30.7549 37.0008 30.7042 35.4008 35.9229",
    stroke: "#C924A4",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5996 36.5811C19.5996 36.5811 21.6996 39.3171 26.3996 37.1891",
    stroke: "#C924A4",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9004 37.4425C25.9004 37.4425 27.3504 40.1785 31.2504 39.1652C31.4504 39.0638 31.6504 38.9118 32.2504 39.1652C32.8504 39.4185 35.3504 40.1278 36.2004 37.4425C36.3504 36.3785 36.3004 35.6185 35.7004 34.9092",
    stroke: "#C924A4",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1992 42.8642L14.6492 38.8108V40.6348L18.5492 38.5068L13.9492 42.8642L13.7992 40.9388L10.1992 42.8642Z",
    fill: "#E5A951"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7996 41.2422L24.5996 47.7275L22.8996 46.3595L21.8496 50.7675L22.0996 44.0289L23.1496 45.0422L24.7996 41.2422Z",
    fill: "#E5A951"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5996 40.584L34.2496 45.144L34.7996 43.5227L37.1496 46.2587L34.6496 41.4453L34.0496 42.9147L31.5996 40.584Z",
    fill: "#E5A951"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13185_1832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressIcon);
export default __webpack_public_path__ + "static/media/stress-icon.4e9e1aae303140413105ee9bdaaa4a7e.svg";
export { ForwardRef as ReactComponent };